enum DragAndDropItemEventEnum {
	dragItem = 'dragItem',
	invalidDrag = 'invalidDrag',
	ghostPositionUpdate = 'ghostPositionUpdate'
}

export default DragAndDropItemEventEnum;
